import { create } from 'zustand';

export const useSessionStore = create((set) => ({
    // type: success/error
    endSession: {
        show: false,
        color: 'green'
    },
    setEndSession: (endSession) => set((prevState) => ({ endSession: { ...prevState, ...endSession } }))
}));

export default useSessionStore;
